// rc128 — Sección "Plantillas" extraída de la vieja AjustesPage (sub-pestañas
// contrato / facturas / recibo). Vive como componente propio para que la
// portada de tarjetas la abra igual que a las demás.
import { useState } from "react";
import { FileText, Receipt, Printer } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PlantillaContratoSection } from "./PlantillaContratoSection";
import { PlantillaFacturaSection } from "./PlantillaFacturaSection";
import { PlantillaReciboPagoSection } from "./PlantillaReciboPagoSection";

export function PlantillasSection() {
  const [sub, setSub] = useState("contrato");
  return (
    <div className="flex flex-col gap-3">
      <p className="text-xs text-muted-foreground">
        Edita las plantillas HTML+Jinja2 que se usan para generar los PDFs de contrato,
        factura y recibo. Los cambios aplican a los PDFs que se generen de aquí en
        adelante; no se regeneran PDFs ya descargados.
      </p>
      <Tabs value={sub} onValueChange={setSub}>
        <TabsList>
          <TabsTrigger value="contrato"><FileText size={12} className="mr-1" />Contrato</TabsTrigger>
          <TabsTrigger value="facturas"><Receipt size={12} className="mr-1" />Facturas</TabsTrigger>
          <TabsTrigger value="recibo-pago"><Printer size={12} className="mr-1" />Recibo pago</TabsTrigger>
        </TabsList>
        <TabsContent value="contrato"><PlantillaContratoSection /></TabsContent>
        <TabsContent value="facturas"><PlantillaFacturaSection /></TabsContent>
        <TabsContent value="recibo-pago"><PlantillaReciboPagoSection /></TabsContent>
      </Tabs>
    </div>
  );
}
